import { forwardRef, useCallback } from "react";
import { FormControl } from "@material-ui/core"
import { Label, InputWrapperDiv, TextAreaField, ErrorText } from "./textarea.style";

const Textarea = forwardRef(
    (
        {
            id,
            name,
            label,
            required,
            value,
            error,
            fullWidth,
            className,
            onChange,
            isMobile,
            ...remainingProps
        }, ref
    ) => {
        const labelId = label ? `${id}-label` : undefined;
        const errorId = error ? `${id}-error-text` : undefined;

        const handleChange = useCallback(
            (event) => {
                onChange(event);
            },
            [onChange]
        );


        return (
            <FormControl fullWidth={fullWidth}>
                {label && (
                    <Label id={labelId} htmlFor={id}>
                        {`${label}${required ? "*" : ""}`}
                    </Label>
                )}
                <InputWrapperDiv>

                    <TextAreaField
                        id={id}
                        ref={ref}
                        name={name}
                        value={value}
                        required={required}
                        aria-invalid={!!error}
                        aria-describedby={errorId}
                        onChange={handleChange}
                        className={className}
                        error={error}
                        isMobile={isMobile}
                        {...remainingProps}
                    />
                </InputWrapperDiv>
                {error && (
                    <ErrorText
                        initial="pageInitial"
                        animate="pageAnimate"
                        exit="pageExit"
                        variants={{
                            pageInitial: {
                                opacity: 1,
                                x: 0,
                                y: -5,
                            },
                            pageAnimate: {
                                opacity: 1,
                                x: 0,
                                y: 0,
                            },
                            pageExit: {
                                opacity: 0,
                            },
                        }}
                        id={errorId}
                    >
                        {error}
                    </ErrorText>
                )}
            </FormControl>
        )
    })

export { Textarea }
